// extracted by mini-css-extract-plugin
module.exports = {"icon":"RegisterForm_icon__1Y7VG","mb1":"RegisterForm_mb1__2E7vO","mb2":"RegisterForm_mb2__1WOxF"};